import axios from "axios";

export default {
  install: function (Vue, params = {}) {

    // Add a request interceptor
    axios.interceptors.request.use(
        async config => {
          config.headers['Content-Type'] = 'application/json';

          if (config.payment && config.payment === true) {
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
          }

          if (config.url.includes("/timeout") || config.url.includes("/landing")
              || config.url.includes("/requestAccess") || config.url.includes("/thanks")) {
            // this endpoint is public and does not require a jwt
            return config;
          }

          if (config.ignoreHeader && config.ignoreHeader === true) {
            return config
          }

          const keycloak = Vue.prototype.$keycloak;
          if (keycloak.authenticated) {
            await keycloak.updateToken(30)
            config.headers['Authorization'] = 'Bearer ' + keycloak.token;
          }
          return config;
        },
        error => {
          Promise.reject(error)
        });

  }
}
